define(function (require) {
  var $ = require("jquery");
  var _ = require("underscore");
  var scrollTo = require("common/util/scrollto");
  var modalWindow = require("site/mobile/modal-window");

  var MAX_DISPLAY_ERRORS = 3;

  function errorPopup (popupName, firstError) {
    var $page = $.mobile.pageContainer.pagecontainer("getActivePage");
    var $popup = typeof popupName === "object" ?
      $page.find(popupName).popup() :
      $("#" + popupName + "-" + $page.attr("id"));

    // hide modal window
    modalWindow.hide();
    // don"t add popup to browser history
    $popup.popup({
      history: false
    });
    // open popup
    $popup.popup("open");
    // run function after popup is closed
    $popup.one("popupafterclose", function () {
      if (firstError) {
        scrollTo(firstError, 300);
      }
    });
  }

  function populateErrors (popup, errorList) {
    var $errorsContainer = $(".errors", popup);
    var $remainingErrors = $(".remaining-errors", popup);
    var $remainingErrorsCount = $(".remaining-errors-count", $remainingErrors);
    var errorMessageArray = [];
    var e;

    for (e = 0; e < errorList.length; e++) {
      errorMessageArray.push(errorList[e].message);
    }

    _.uniq(errorMessageArray);
    var errorsToShow = Math.min(errorMessageArray.length, MAX_DISPLAY_ERRORS);
    var remainingErrors = errorMessageArray.length - errorsToShow;

    $("li", $errorsContainer).not($remainingErrors).remove();

    for (e = 0; e < errorsToShow; e++) {
      var error = errorMessageArray[e];
      var $error = $("<li>").text(error);

      $remainingErrors.before($error);
    }

    if (remainingErrors > 1) {
      $remainingErrorsCount.text(remainingErrors);
      $(".error-single").hide();
      $(".error-multi").show();
      $remainingErrors.show();
    } else if (remainingErrors === 1) {
      $remainingErrorsCount.text(remainingErrors);
      $(".error-single").show();
      $(".error-multi").hide();
      $remainingErrors.show();
    } else {
      $remainingErrors.hide();
    }
  }

  function validateOptions (options, errorPopupSelector) {
    var baseOptions = {
      ignore: ":hidden",
      errorPlacement () {
        return false;
      },
      focusInvalid: false,
      invalidHandler (form, validator) {
        var invalidField = validator.errorList[0].element;
        var $errorPopup = $(errorPopupSelector);

        populateErrors($errorPopup, validator.errorList);
        errorPopup($errorPopup, invalidField);
      },
      highlight (element, errorClass) {
        $(element).addClass(errorClass);
        $(element).parents("li").addClass(errorClass);
      },
      unhighlight (element, errorClass) {
        $(element).removeClass(errorClass);
        $(element).parents("li").removeClass(errorClass);
      }
    };

    return $.extend(baseOptions, options);
  }

  return {
    options: validateOptions,
    errorPopup: errorPopup
  };
});
